/**
 * The Tours carousel block — the Tours block's tours, as the slides of a real
 * Carousel instead of a grid.
 *
 * IT ASKS THE SAME QUESTION. The list node stores `source`, `categories`,
 * `tours` and `limit` under the Tours block's names, and `contentRequestOf`
 * answers it with `tourCardsRequest`. So the server path is the Tours
 * block's, and a grid and a carousel with the same query are one read — the
 * Categories grid's arrangement with the Categories carousel
 * (`category-grid.ts`), the other way round.
 *
 * The card settings (`showDestination`, `facts`, `details`, `layout`) are read
 * with the Tours block's readers (`tour-cards.ts`). The grid's own layout
 * settings — columns, the phone's scrolling row, the gap — have no meaning
 * here: the Carousel around the list owns per view, peek and gap.
 */
export const TOUR_CAROUSEL_TYPE = "tour-carousel";
